export default Object.freeze({
    ID_NAGOYA: '1',
    ID_OKAZAKI: '2'
});
